import {
  EC_COMPLETE_SLUG,
  EC_FORM_SLUG,
  EC_IN_PROGRESS_SLUG,
  EC_SUCCESS_SLUG,
  EC_UPGRADE_SLUG,
  ECSlug,
} from '@src/pages/ExpertCheck/constants'
import * as Cookies from 'js-cookie'
import { createSelector } from 'reselect'
import { getPaidMember, getUserID } from '../auth/selectors'
import { RootState } from '../types'

export const ZOHO_COOKIE = 'wfe_zoho'

export const getExpertCheckLoadingState = (state: RootState) =>
  state.expertCheck.isCreatingTicket
export const getExpertCheckTicketId = (state: RootState) => state.expertCheck.ticketId
export const getExpertCheckError = (state: RootState) =>
  state.expertCheck.createTicketError
export const getShowSuccessPage = (state: RootState) =>
  state.expertCheck.redirectToSuccessPage
export const getFeedbackDate = (state: RootState) => state.expertCheck.feedbackDate
export const getFeedbackContent = (state: RootState) =>
  state.expertCheck.feedbackContent || {}
export const getFeedbackIsInProgress = createSelector(
  getFeedbackContent,
  ({ feedbackInApp, feedbackAvailable, feedbackIsValid }) =>
    !!(feedbackInApp && (!feedbackAvailable || !feedbackIsValid))
)
export const getFeedbackIsAvailable = createSelector(
  getFeedbackContent,
  ({ feedbackInApp, feedbackAvailable, feedbackIsValid }) =>
    !!(feedbackInApp && feedbackAvailable && feedbackIsValid)
)
export const selectShouldSubmitOnload = (state: RootState) =>
  !!state.expertCheck.shouldSubmitOnload

export const getNetworkError = (state: RootState) => !!state.expertCheck.networkError

export const selectZohoCookie = createSelector([getUserID], (userId): boolean => {
  if (userId) {
    const COOKIE_NAME = `${ZOHO_COOKIE}-${userId}`
    const cookie = Cookies.get(COOKIE_NAME)
    if (cookie) {
      return true
    }
  }
  return false
})

export const selectECSlug = createSelector(
  [
    getPaidMember,
    getExpertCheckTicketId,
    selectZohoCookie,
    getShowSuccessPage,
    getFeedbackIsInProgress,
    getFeedbackIsAvailable,
  ],
  (
    isPaid,
    ticketId,
    hasZohoCookie,
    showSuccess,
    FeedbackIsInProgress,
    FeedbackIsAvailable
  ): ECSlug => {
    const hasTicket = !!ticketId

    if (FeedbackIsAvailable) {
      return EC_COMPLETE_SLUG
    }

    if (hasTicket || hasZohoCookie || FeedbackIsInProgress) {
      return showSuccess ? EC_SUCCESS_SLUG : EC_IN_PROGRESS_SLUG
    }

    if (!isPaid) {
      return EC_UPGRADE_SLUG
    }

    return EC_FORM_SLUG
  }
)



// WEBPACK FOOTER //
// ./src/state/expertcheck/selectors.ts